{
  "(optional)": "(opcionális)",
  "(required)": "(kötelező)"
}
